import { createSlice } from "@reduxjs/toolkit";

interface OnboardingState {
  hasOnboarded: boolean;
}

const initialState: OnboardingState = {
  hasOnboarded: localStorage.getItem("hasOnboarded") === "true",
};

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    markOnboarded: (state) => {
      state.hasOnboarded = true;
      localStorage.setItem("hasOnboarded", "true");
    },
  },
});

export const { markOnboarded } = onboardingSlice.actions;
export default onboardingSlice.reducer;
